import React from 'react';
import Spinner from 'react-spinkit';

const Loading = () => (
  <Spinner name='circle' fadeIn='none' />
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/partials/loading/loading.js